<div
  (click)="onClick()"
  class="card flex-c align-start"
  [class.selected]="card.selected"
  [ngStyle]="{ '--bg-color': card.color80, '--text-color': card.color0 }"
  [class.default]="!card.class"
  [class.default-hover]="!card.class"
  [class]="!card.class ? '' : card.class + ' ' + card.class + '-hover'">
  <div class="card-title">
    @if (card.titleIcon) {
      <i class="fa-regular {{ card.titleIcon }}"></i>
    }
    <span class="title-text">
      {{ card.title }}
    </span>
  </div>
  <div class="card-details font-color-black">
    {{
      isDetailsObservable(card.details)
        ? (card.details | async) || 'Loading...'
        : card.details || ''
    }}
  </div>
</div>
